<template>
  <v-card class="ma-0" :maxHeight="height" :minHeight="minHeight">
    <v-card-title class="error white--text py-0" @click="fitchData"> Задачи для проверки ({{ data.length }}) </v-card-title>
    <v-divider />
    <v-card-text class="mt-0 pa-1 pt-0">
      <v-simple-table v-if="data.length > 0" fixed-header dense :height="height - 36" ref="tableTaskChecking">
        <template v-slot:default>
          <thead class="main-table-header">
            <tr>
              <th class="text-left px-1"></th>
              <th class="text-left px-1">Дэдлайн</th>
              <th class="text-left px-1">Заголовок</th>
              <th class="text-left px-1">Исполнитель</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(el, i) in data.slice(0, itemsPerPage)" :key="i" @click="$emit('click', { id: el.id, row: el })" style="cursor: pointer">
              <td class="text-left px-1">
                <a-view-table-chip
                  :value="el.is_important"
                  :model="{
                    hideText: true,
                    showText: el.id,
                    options: $store.getters['config/get'].models.tasks.optionsIsImportant,
                  }"
                />
              </td>
              <td class="text-left px-1">
                <a-view-table-date :value="el.date_end" />
              </td>
              <td class="text-left px-1">
                <a-view-table-taskname :value="el.name" :values="el" />
              </td>
              <td class="text-left px-1">
                <a-view-table-string :value="el.user_name" />
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <div v-else>Список пуст</div>
    </v-card-text>
  </v-card>
</template>

<script>
import { getAccess } from "@/components/mixings";
export default {
  mixins: [getAccess],
  components: {
    Widget: () => import("./widgets/sqlTable"),
  },
  props: {
    height: { type: Number, default: 0 },
    rows: Array,
  },
  data() {
    return {
      itemsPerPage: 50,
      showTaskDialog: false,
      contentHeight: 10,
      idEdit: 0,
      loading: false,
      data: [],
      model: [
        { name: "id", hidden: true },
        {
          name: "is_important",
          type: "chip",
          hideText: true,
          showText: { field: "id" },
          options: this.$store.getters["config/get"].models.tasks.optionsIsImportant,
          width: 50,
        },
        { name: "date_end", title: "Дэдлайн", type: "date", width: 80, sortable: true },
        { name: "name", title: "Заголовок", type: "string", width: 250 },
        { name: "status", title: "Статус", type: "select", options: this.$store.getters["config/get"].models.tasks.statuses },
      ],
    };
  },
  mounted() {
    document.addEventListener("scroll", this.onScroll, true);
  },
  destroyed() {
    document.removeEventListener("scroll", this.onScroll, true);
  },
  created() {
    this.fitchData();
  },
  computed: {
    minHeight() {
      let h = this.height;
      if (this.$vuetify.breakpoint.name == "xs" && this.data.length == 0) {
        h = 0;
      }
      return h;
    },
  },
  methods: {
    onScroll(e) {
      if (!this.data.length) return;
      let el = this.$refs.tableTaskChecking;
      let offset = 200;
      el = el.$el.querySelector(".v-data-table__wrapper");
      if (e.target == el) {
        if (el.scrollHeight - el.offsetHeight <= el.scrollTop + offset) {
          this.itemsPerPage += this.itemsPerPage < this.data.length - 50 ? 50 : this.data.length - this.itemsPerPage;

          //  this.$emit("scrollEnd", e);
        }
      }
    },
    async fitchData() {
      let list = [];
      this.loading = true;
      if (true) {
        try {
          console.log(this.$root.profile);
          const api = "/mechti/tasks";
          let d = await this.$axios.get(api, { params: { filters: { status: 2, createdby_id: this.$root.profile.id } } });
          list = [
            ...list,
            ...(d?.data?.data || []).map(m => {
              m._api = api;
              return m;
            }),
          ];
        } catch (error) {
          console.error(error);
        }
      }
      if (this.getAccess("task.viewOverseer") && false) {
        try {
          const api = "/mechti/tasks-department-director-overseer";
          let d = await this.$axios.get(api, { params: { filters: { status: 2 } } });
          list = [
            ...list,
            ...(d?.data?.data || []).map(m => {
              m._api = api;
              return m;
            }),
          ];
        } catch (error) {
          console.error(error);
        }
      }
      if (!!(this.$root.profile?.my_departments || []).length && false) {
        try {
          const api = "/mechti/tasks-department-director";
          let d = await this.$axios.get("/mechti/tasks-department-director", {
            params: { filters: { status: 2, user_id: { condition: "<>", value: this.$root.profile.id } } },
          });
          list = [
            ...list,
            ...(d?.data?.data || []).map(m => {
              m._api = api;
              return m;
            }),
          ];
        } catch (error) {
          console.error(error);
        }
      }
      this.data = [...list];
      this.loading = false;
    },
  },
};
</script>
